export * from './components/index.ts';

import { initialise as initialise_google_analytics } from './google-analytics';
import { initialise as initialise_google_tag_manager } from './google-tag-manager';
import { initialise as initialise_clarity } from './clarity';
import { IAnalytics, analytics_service_factory } from './use-cases';

type Props = {
    google_token: string;
    gtm_token: string;
    clarity_token: string;
}

function initialise({ google_token, gtm_token, clarity_token }: Props): Promise<IAnalytics> {
    return Promise.all([
        initialise_clarity(clarity_token),
        initialise_google_analytics(google_token),
        initialise_google_tag_manager(gtm_token),
    ]).then(([clarity, gtag, dataLayer]) =>
        analytics_service_factory(dataLayer, gtag, clarity)
    );
}

export {
    IAnalytics,
    initialise,
    initialise_google_tag_manager,
    analytics_service_factory,
};
